import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Trending from './components/Trending';
import Playlists from './components/Playlists';
import Profile from './components/Profile';
import SongPlayerPage from './components/SongPlayerPage';
import PlaylistsDetails from './components/PlaylistsDetails';
import Library from './components/Library'; // Import Library component
import Login from './components/Login';
import TokenHandler from './components/TokenHandler'; // Import TokenHandler
import { clearSpotifyAuth } from './auth';
import './App.css';

const App = () => {
  const [token, setToken] = useState(null);
  const [authError, setAuthError] = useState('');
  const [authReady, setAuthReady] = useState(false);

  const handleLogout = () => {
    clearSpotifyAuth();
    setToken(null);
  };

  return (
    <Router>
      <div className="App">
        <TokenHandler setToken={setToken} setAuthError={setAuthError} setAuthReady={setAuthReady} />
        {token ? (
          <>
            <Sidebar onLogout={handleLogout} />
            <div className="content">
              <Routes>
                <Route path="/" element={<Trending token={token} />} />
                <Route path="/playlists" element={<Playlists token={token} />} />
                <Route path="/playlist/:id" element={<PlaylistsDetails token={token} />} />
                <Route path="/profile" element={<Profile token={token} />} />
                <Route path="/library" element={<Library token={token} />} /> {/* Add Library route */}
                <Route path="/song/:id" element={<SongPlayerPage token={token} />} />
              </Routes>
            </div>
          </>
        ) : (
          authReady ? <Login error={authError} /> : <div>Checking Spotify session...</div>
        )}
      </div>
    </Router>
  );
};

export default App;
